import  React from 'react'
import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'

import { Dialog } from './Dialog'
import { addOnTimeout, removeOnTimeout, alertBeforeTimeout } from './Timeout'
import { PingController } from '../controllers/PingController'

export interface TimeoutPopupProps {
    onLogout?: { (): any }
}

export interface TimeoutPopupState {
    popup: boolean
    sessionTimedOut: boolean
}

export class TimeoutPopup extends React.Component<TimeoutPopupProps, TimeoutPopupState> {
    ajax: PingController
    sessionTimoutTimer: NodeJS.Timeout

    constructor(props: TimeoutPopupProps) {
      super(props)

      this.ajax = new PingController()

      this.state = {
        popup: false,
        sessionTimedOut: false,
      }
    }

    onAlert = () => {
      this.setState({ popup: true }, () => {
        this.sessionTimoutTimer = setTimeout(() => { this.setState({ sessionTimedOut: true }) }, alertBeforeTimeout)
      })
    }

    onLogout = () => {
      this.setState({ popup: false }, () => {
        if (this.props.onLogout) { this.props.onLogout() }

        window.location.href = `/login?returnUrl=${encodeURIComponent(window.location.pathname)}`
      })
    }

    onPing = () => {
      this.ajax.keepAlive(null, (success) => {
        clearTimeout(this.sessionTimoutTimer)

        this.setState({
          popup: false,
          sessionTimedOut: false,
        }, () => {
          // TODO: Fix - calling again to reset timout cookie
          this.ajax.keepAlive(null, (success) => { })
        })
      })
    }

    componentDidMount() {
      addOnTimeout(this.onAlert)
    }

    componentWillUnmount() {
      removeOnTimeout(this.onAlert)

      if (this.sessionTimoutTimer) { clearTimeout(this.sessionTimoutTimer) }
    }

    render() {
      return (
        <Dialog
          id="timeoutPopup"
          title="Session time out"
          open={this.state.popup}
          onClose={this.onLogout}
          footer={(
            <div>
              <div style={{ display: this.state.sessionTimedOut ? 'none' : '' }}>
                <Button className="emdg-btn emdg-btn--secondary mr-3" onClick={this.onLogout}>Logout</Button>
                {' '}
                <Button className="emdg-btn" onClick={this.onPing}>Stay logged-in</Button>
              </div>
              <div style={{ display: this.state.sessionTimedOut ? '' : 'none' }}>
                <Button className="emdg-btn emdg-btn--secondary mr-3" onClick={this.onLogout}>Ok</Button>
              </div>
            </div>
              )}
        >

          <div style={{ display: this.state.sessionTimedOut ? 'none' : '' }}>
            <Alert className="emdg-page-alerts">
              <p>
                You are about to timed out.
                <br />
                Click on the 'Stay logged-in' button to continue working on the form.
              </p>
            </Alert>
          </div>
          <div style={{ display: this.state.sessionTimedOut ? '' : 'none' }}>
            <Alert className="emdg-page-alerts emdg-page-alerts--warning ">
              <p>
                For security reasons, your session has timed out due to inactivity.
              </p>
            </Alert>
          </div>
        </Dialog>
      )
    }
}
